<template>
  <p class="p-site-keyword-analysis-status">
    <Label size="lg" variant="main">{{ label.name[sort.name] }}</Label>
    <slot>の{{ label.orderby[sort.orderby] }}</slot>
  </p>
</template>

<script>
import Label from '@/components/Label';

export default {
  props: {
    sort: {
      type: Object,
      required: true
    }
  },
  components: {
    Label
  },
  data() {
    return {
      label: {
        name: {
          rank: '平均順位',
          searchVolume: '月間検索数',
          impressions: '表示回数',
          ctr: 'クリック率',
          influx: '流入数',
          directConversion: '直接CV',
          assistedConversion: '間接CV',
          directConversionRate: '直接CVR',
          assistedConversionRate: '間接CVR',
          url: '流入先URL',
          title: 'タイトル'
        },
        orderby: {
          asc: '昇順',
          desc: '降順'
        }
      }
    };
  },
  watch: {
    sort: {
      handler() {
        this.blink();
      }
    }
  },
  methods: {
    blink() {
      this.$el.classList.remove('is-blink');
      setTimeout(() => {
        this.$el.classList.add('is-blink');
      }, 0);
    }
  }
};
</script>
